// extracted by mini-css-extract-plugin
export default {"teamMemberCard":"TeamMemberCard_teamMemberCard__fwCZL","cardContent":"TeamMemberCard_cardContent__PolfD"};